<div class="home-page">
    <form>
        <div class="container">
            <div class="text-center">
                <h2>Loading...</h2>
            </div>            
        </div>
    </form>
</div>